import React, { useState, useEffect } from "react";
import { DatePicker, Select, Button, Row, Col, Typography, Space } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import moment from "moment";

const { RangePicker } = DatePicker;
const { Option } = Select;

const TimeRangeSelector = ({ onUpdate, startDate, endDate, groupBy, selectedRange }) => {
  const [daysAgo, setDaysAgo] = useState(7);

  const applyUpdate = (start, end, group = groupBy, range = null) => {
    onUpdate(start, end, group, range);
  };

  const handlePredefinedRangeSelect = (range) => {
    let start, end;
    const today = moment();

    switch (range) {
      case "today":
        start = end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = end = today.subtract(1, "day").format("YYYY-MM-DD");
        break;
      case "thisWeek":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "previousWeek":
        start = today.subtract(1, "week").startOf("week").format("YYYY-MM-DD");
        end = moment(start).endOf("week").format("YYYY-MM-DD");
        break;
      case "thisMonth":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      case "previousMonth":
        start = today.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
        end = moment(start).endOf("month").format("YYYY-MM-DD");
        break;
      case "thisYear":
        start = today.startOf("year").format("YYYY-MM-DD");
        end = today.endOf("year").format("YYYY-MM-DD");
        break;
      case "previousYear":
        start = today.subtract(1, "year").startOf("year").format("YYYY-MM-DD");
        end = moment(start).endOf("year").format("YYYY-MM-DD");
        break;
      case "thisQuarter":
        start = today.startOf("quarter").format("YYYY-MM-DD");
        end = today.endOf("quarter").format("YYYY-MM-DD");
        break;
      case "previousQuarter":
        start = today.subtract(1, "quarter").startOf("quarter").format("YYYY-MM-DD");
        end = moment(start).endOf("quarter").format("YYYY-MM-DD");
        break;
      case "daysAgo":
        start = today.subtract(daysAgo, "days").format("YYYY-MM-DD");
        end = moment().format("YYYY-MM-DD");
        break;
      case "primerTrimestre":
        start = today.startOf("year").format("YYYY-MM-DD");
        end = today.month(2).endOf("month").format("YYYY-MM-DD");
        break;
      case "segundoTrimestre":
        start = today.month(3).startOf("month").format("YYYY-MM-DD");
        end = today.month(5).endOf("month").format("YYYY-MM-DD");
        break;
      case "tercerTrimestre":
        start = today.month(6).startOf("month").format("YYYY-MM-DD");
        end = today.month(8).endOf("month").format("YYYY-MM-DD");
        break;
      case "cuartoTrimestre":
        start = today.month(9).startOf("month").format("YYYY-MM-DD");
        end = today.endOf("year").format("YYYY-MM-DD");
        break;
      case "enero":
        start = today.month(0).startOf("month").format("YYYY-MM-DD");
        end = today.month(0).endOf("month").format("YYYY-MM-DD");
        break;
      case "febrero":
        start = today.month(1).startOf("month").format("YYYY-MM-DD");
        end = today.month(1).endOf("month").format("YYYY-MM-DD");
        break;
      case "marzo":
        start = today.month(2).startOf("month").format("YYYY-MM-DD");
        end = today.month(2).endOf("month").format("YYYY-MM-DD");
        break;
      case "abril":
        start = today.month(3).startOf("month").format("YYYY-MM-DD");
        end = today.month(3).endOf("month").format("YYYY-MM-DD");
        break;
      case "mayo":
        start = today.month(4).startOf("month").format("YYYY-MM-DD");
        end = today.month(4).endOf("month").format("YYYY-MM-DD");
        break;
      case "junio":
        start = today.month(5).startOf("month").format("YYYY-MM-DD");
        end = today.month(5).endOf("month").format("YYYY-MM-DD");
        break;
      case "julio":
        start = today.month(6).startOf("month").format("YYYY-MM-DD");
        end = today.month(6).endOf("month").format("YYYY-MM-DD");
        break;
      case "agosto":
        start = today.month(7).startOf("month").format("YYYY-MM-DD");
        end = today.month(7).endOf("month").format("YYYY-MM-DD");
        break;
      case "septiembre":
        start = today.month(8).startOf("month").format("YYYY-MM-DD");
        end = today.month(8).endOf("month").format("YYYY-MM-DD");
        break;
      case "octubre":
        start = today.month(9).startOf("month").format("YYYY-MM-DD");
        end = today.month(9).endOf("month").format("YYYY-MM-DD");
        break;
      case "noviembre":
        start = today.month(10).startOf("month").format("YYYY-MM-DD");
        end = today.month(10).endOf("month").format("YYYY-MM-DD");
        break;
      case "diciembre":
        start = today.month(11).startOf("month").format("YYYY-MM-DD");
        end = today.month(11).endOf("month").format("YYYY-MM-DD");
        break;
      default:
        return;
    }

    applyUpdate(start, end, groupBy, range);
  };

  return (
    <Space direction="vertical" size={2}>
      <Typography.Text strong style={{ fontSize: '12px' }}>Rango de fechas</Typography.Text>
      <Row gutter={[8, 8]} align="middle">
        <Col>
          <RangePicker
            size="small"
            value={[moment(startDate), moment(endDate)]}
            onChange={(dates) => applyUpdate(dates[0].format("YYYY-MM-DD"), dates[1].format("YYYY-MM-DD"), groupBy, null)}
            format="DD/MM/YYYY"
            style={{ width: 220 }}
          />
        </Col>

        <Col>
          <Select size="small" value={groupBy} onChange={(val) => applyUpdate(startDate, endDate, val, selectedRange)} style={{ width: 110 }}>
            <Option value="daily">Por día</Option>
            <Option value="weekly">Por semana</Option>
            <Option value="monthly">Por mes</Option>
            <Option value="yearly">Por año</Option>
          </Select>
        </Col>
        <Col>
          <Select
            size="small"
            style={{ width: 160 }}
            onChange={handlePredefinedRangeSelect}
            value={selectedRange}
            placeholder="Predefinidos"
            options={[
              { label: "Ayer y Hoy", options: [{ label: "Hoy", value: "today" }, { label: "Ayer", value: "yesterday" }] },
              { label: "Semana", options: [{ label: "Semana Actual", value: "thisWeek" }, { label: "Semana Pasada", value: "previousWeek" }] },
              { label: "Mes", options: [{ label: "Mes Actual", value: "thisMonth" }, { label: "Mes Pasado", value: "previousMonth" }] },
              { label: "Año", options: [{ label: "Año Actual", value: "thisYear" }, { label: "Año Pasado", value: "previousYear" }] },
              { label: "Trimestres Genéricos", options: [{ label: "Trimestre Actual", value: "thisQuarter" }, { label: "Trimestre Pasado", value: "previousQuarter" }] },
              { label: "Trimestres Fijos", options: [{ label: "1er Tri", value: "primerTrimestre" }, { label: "2do Tri", value: "segundoTrimestre" }, { label: "3er Tri", value: "tercerTrimestre" }, { label: "4to Tri", value: "cuartoTrimestre" }] },
              { label: "Meses", options: [
                { label: "Ene", value: "enero" }, { label: "Feb", value: "febrero" }, { label: "Mar", value: "marzo" }, 
                { label: "Abr", value: "abril" }, { label: "May", value: "mayo" }, { label: "Jun", value: "junio" }, 
                { label: "Jul", value: "julio" }, { label: "Ago", value: "agosto" }, { label: "Sep", value: "septiembre" }, 
                { label: "Oct", value: "octubre" }, { label: "Nov", value: "noviembre" }, { label: "Dic", value: "diciembre" }
              ] },
            ]}
          />
        </Col>
      </Row>
    </Space>
  );
};

export default TimeRangeSelector;
